import { render, staticRenderFns } from "./BText.vue?vue&type=template&id=7d8ac0fe&scoped=true&"
import script from "./BText.vue?vue&type=script&lang=js&"
export * from "./BText.vue?vue&type=script&lang=js&"
import style0 from "./BText.vue?vue&type=style&index=0&id=7d8ac0fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8ac0fe",
  null
  
)

export default component.exports